import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import Logo from "@/components/Logo";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const { setSession } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams((window.location.hash || "").replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const token = params.get("token");
    const error = params.get("error");

    (async () => {
      try {
        if (error) throw new Error(error);
        let user;
        if (sessionId) {
          const { data } = await api.post("/auth/google/session", { session_id: sessionId });
          user = await setSession(data.token, data.user);
        } else if (token) {
          user = await setSession(token, null);
        } else {
          throw new Error("No session");
        }
        window.history.replaceState({}, "", "/auth/callback");
        toast.success(`Welcome, ${user.name}`);
        const next = sessionStorage.getItem("kc_next");
        sessionStorage.removeItem("kc_next");
        const home = user.role === "admin" ? "/admin" : user.role === "driver" ? "/driver" : "/dashboard";
        navigate(user.role === "customer" && next?.startsWith("/") ? next : home, { replace: true });
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background" data-testid="auth-callback">
      <Logo />
      <div className="flex items-center gap-2 text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin text-primary" /> Signing you in…
      </div>
    </div>
  );
}
